.wrapper {
  position: relative;
  padding: 0 18px;
  height: var(--current-legend-height);
  flex-shrink: 0;
  overflow: visible;
  transition: height 200ms ease-in;
  background-color: #ffffff;
  color: var(--color-neutral-400);
  font-size: 12px;
}

.collapse-btn {
  position: absolute;
  right: 36px;
  top: 0;
  transform: translateY(-50%);
  transition: top 300ms ease-in;
}

.collapse-btn-up {
  top: -8px;
}

.content {
  display: flex;
  align-items: center;
  gap: 12px;
  transition: opacity 300ms ease-in;
}

.content-collapsed {
  opacity: 0;
  pointer-events: none;
}

.title {
  white-space: nowrap;
}

.item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.rectangle {
  width: 6px;
  height: 20px;
  border-radius: 10px;
  flex-shrink: 0;
}
.rectangle-not-started {
  background-color: var(--color-neutral-400);
}
.rectangle-in-progress {
  background-color: #559CF8;
}
.rectangle-completed {
  background-color: var(--color-feedback-positive-300);
}
.rectangle-error {
  background-color: #FFC629;
}
.rectangle-not-executed {
  background-color: var(--color-feedback-danger-300);
}
.rectangle-awaiting-justification {
  background-color: var(--feedback-danger-400, var(--color-feedback-danger-400, #AE1E1E));
}

.label {
  color: var(--color-neutral-500);
}

.divider {
  all: unset;
  display: block;
  width: 1.3px;
  height: 24px;
  flex-shrink: 0;
  background-color: var(--color-neutral-300);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */